module.exports = __webpack_public_path__ + "static/media/Lock_grey.faecd778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/Lock_grey.svg
// module id = 615
// module chunks = 0